<template>
    <div class="mobile-nav-actions">
        <div class="icon-actions">
            <ThemeSwitcherIcon @click="useThemeStore.toggle()" />
            <p v-if="!onlyThemeSwitcher" @click="goAbout" class="cursor-pointer">about</p>
            <LiquidTrademarkIcon v-if="!onlyThemeSwitcher" />
        </div>
    </div>
</template>

<style scoped>
.mobile-nav-actions {
    display: none;
    touch-action: none;
}

.icon-actions {
    display: flex;
    gap: 40px;
    height: calc(33.45% + 60px);
    justify-content: space-between;
    pointer-events: all;
    padding-top: 60px;
    touch-action: none;
    -webkit-user-select: none;
    user-select: none;
}

.icon-actions p {
    font-size: 18px;
    line-height: 24px;
}

@media (max-width: 996px) {
    .mobile-nav-actions {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: fixed;
        z-index: 60;
        letter-spacing: var(--action-letter-spacing);
        height: 33.86vh;
        width: 100%;
        bottom: 0;
        left: 0;
        padding: 0 45px;
        pointer-events: none;

        /** Blur Overlay */
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        mask-image: linear-gradient(to top, var(--background-color) 40%, transparent 100%);
        -webkit-mask-image: linear-gradient(to top, var(--background-color) 40%, transparent 100%);
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 24%, var(--background-color) 100%);
    }
}

@media (max-width: 996px) {
    .mobile-nav-actions {
        padding: 0 15px;
    }
}
</style>

<script setup>
import { useThemeStore } from '@/stores/useThemeStore';
import ThemeSwitcherIcon from '../atoms/theme-switcher-icon.vue';
import LiquidTrademarkIcon from '../atoms/liquid-trademark-icon.vue';
import { useRouter } from 'vue-router';

const router = useRouter()

const props = defineProps({ onlyThemeSwitcher: Boolean, default: false })

function goAbout() {
    router.push('/about')
}
</script>